export enum Modules {
    ENTIA = 'entia',
    LIGHTS = 'lights',
}
